var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var BaseMap = require('../../../../include/_js/maps/BaseMap');

        /**
         * @deprecated
         * Заточена на только 1 точку на карте, как и текущий интерфейс
         * @use OfficeMap - по городам
         */

        var OfficeSchemeMap = function (_BaseMap) {
            _inherits(OfficeSchemeMap, _BaseMap);

            /**
             * @param mapId
             * @param lon
             * @param lat
             * @param hint
             */
            function OfficeSchemeMap(mapId, lon, lat, hint) {
                _classCallCheck(this, OfficeSchemeMap);

                var _this = _possibleConstructorReturn(this, (OfficeSchemeMap.__proto__ || Object.getPrototypeOf(OfficeSchemeMap)).call(this));

                _this.map = null;
                _this.loadingStarted = false;

                _this.mapId = mapId;
                _this.mapContainer = document.getElementById(mapId);
                _this.coordinates = {
                    lat: parseFloat(lat),
                    lng: parseFloat(lon)
                };
                _this.hint = hint;
                return _this;
            }

            _createClass(OfficeSchemeMap, [{
                key: "isReady",
                value: function isReady() {
                    return this.map !== null;
                }
            }, {
                key: "init",
                value: function init() {
                    var _this2 = this;

                    if (this.loadingStarted || !this.mapContainer) {
                        return;
                    }
                    this.loadingStarted = true;
                    ymapLoader.load(function () {
                        _this2.map = new ymaps.Map(_this2.mapContainer, {
                            center: [_this2.coordinates.lat, _this2.coordinates.lng],
                            zoom: 17,
                            controls: []
                        });

                        ymapLoader.addToStorage(_this2, $(_this2.mapContainer));
                        var yPlacemark = new ymaps.Placemark([_this2.coordinates.lat, _this2.coordinates.lng], {
                            hintContent: _this2.hint
                        });
                        _this2.map.geoObjects.add(yPlacemark);
                    });
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    if (this.isReady()) {
                        return false;
                    }
                    this.map.destroy();
                    return true;
                }
            }]);

            return OfficeSchemeMap;
        }(BaseMap);

        window.OfficeSchemeMap = OfficeSchemeMap;
    }, { "../../../../include/_js/maps/BaseMap": 2 }], 2: [function (require, module, exports) {
        var BaseMap = function () {
            function BaseMap() {
                _classCallCheck(this, BaseMap);
            }

            _createClass(BaseMap, [{
                key: "isReady",

                /**
                 * @return {boolean}
                 */
                value: function isReady() {
                    return false;
                }

                /**
                 * Инициализация карты
                 */

            }, {
                key: "init",
                value: function init() {}

                /**
                 * Удалить карту. (В основном для yandex карт)
                 */

            }, {
                key: "destroy",
                value: function destroy() {}

                // e.g. map.resize()

            }, {
                key: "refresh",
                value: function refresh() {}
            }]);

            return BaseMap;
        }();

        module.exports = BaseMap;
    }, {}] }, {}, [1]);